import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "src/app/injectable/admin.service";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";
import { AreaInsertByGeoJsonComponent } from "../show-areas/area-insert-by-geo-json/area-insert-by-geo-json.component";
import { AreaInsertByGeojsonRequest } from "../show-areas/area-insert-by-geojson-request";
import { AreaInsertRequest, Coordinate } from "./area-insert-request";
import { InsertAreaDialogComponent } from "./insert-area-dialog/insert-area-dialog.component";

@Component({
  selector: "app-area-insert",
  templateUrl: "./area-insert.component.html",
  styleUrls: ["./area-insert.component.scss"],
})
export class AreaInsertComponent implements OnInit {
  loading = false;
  sub = false;
  coordinates: any;

  constructor(
    private adminService: AdminService,
    private router: Router,
    private snackBar: MatSnackBar,
    private genericErrorModalService: GenericErrorModalService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  onBackButtonClick() {
    this.router.navigate(["/areas"]);
  }

  onAreaChange(coordinates) {
    this.coordinates = coordinates;
  }

  onSaveClick() {
    const dialogRef = this.dialog.open(InsertAreaDialogComponent);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let areaInsertRequest: AreaInsertRequest;
        areaInsertRequest = {
          areaName: result.areaName,
          type: "POLYGON",
          polygonArray: this.coordinates.map((item) => {
            const coord: Coordinate = {
              x: item[1],
              y: item[0],
            };
            return coord;
          }),
        };
        // Chiude il poligono copiando il primo vertice alla fine dell'array ////
        areaInsertRequest.polygonArray.push(areaInsertRequest.polygonArray[0]);
        /////////////////////////////////////////////////////////////////////////
        this.sub = true;
        this.adminService.insertArea(areaInsertRequest).subscribe(
          (res) => {
            this.sub = false;
            this.openSnackBar("Area inserita con successo.", "Chiudi");
            this.router.navigate(["/areas"]);
          },
          (err) => {
            console.error("Errore nell'inserimento dell'Area.", err);
            this.genericErrorModalService.open(
              "Errore durante l'inserimento dell'Area",
              err
            );
            this.sub = false;
          }
        );
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3500,
      panelClass: "custom-snackbar",
    });
  }
}
